import { UniversalSingleSelectWithRHF } from 'components/common/Select/UniversalSingleSelectWithRHF';
import { useIsSupplierPortalProductEditorFieldDisabled } from 'hooks/useUserState_utils';
import { useTranslation } from 'react-i18next';
import { SegmentTag } from 'types/global';

export const PositioningField: React.FC<{ segment: SegmentTag }> = ({
  segment
}) => {
  const { t } = useTranslation();
  const disabled = useIsSupplierPortalProductEditorFieldDisabled();
  return (
    <UniversalSingleSelectWithRHF
      formId={'private_attributes.data.positioning'}
      label={t('forms.product.positioning.label')}
      type="UX_BEAUTY_POSITIONING"
      segment={segment}
      creatable
      disabled={disabled}
    />
  );
};
